import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

/**
 * Cognito（OIDC）認証のラッパーサービス。
 * angular-auth-oidc-client の OidcSecurityService を包み、
 * ヘッダー表示用の認証状態とログアウト処理を一箇所に集約する。
 */
@Injectable({
  providedIn: 'root'
})
export class CognitoAuthService {
  /** ログイン済みかどうか */
  public readonly isAuthenticated$: Observable<boolean>;
  /** Cognito のユーザー情報（IDトークンのクレーム） */
  public readonly userData$: Observable<any>;

  constructor(private oidcSecurityService: OidcSecurityService) {
    this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$.pipe(
      map(result => result.isAuthenticated)
    );
    this.userData$ = this.oidcSecurityService.userData$.pipe(
      map(result => result.userData)
    );
  }

  /**
   * ログイン（Cognito Hosted UI へリダイレクト）
   */
  login(): void {
    this.oidcSecurityService.authorize();
  }

  /**
   * ログアウト処理。
   * Cognito のログアウトは非標準のため、ローカルセッションを破棄した上で
   * Cognito のログアウトエンドポイントへ手動でリダイレクトする
   * （react-oidc-context 側の auth.removeUser() + /logout リダイレクトと同等）。
   * ログアウト後はランディングページへ戻り、autoLoginPartialRoutesGuard により
   * 自動的に Cognito のログイン画面へ遷移する。
   */
  logout(): void {
    const redirectToCognitoLogout = () => {
      const { logoutEndpoint, clientId } = environment.cognito;
      const pvfLandingUrl = new URL(environment.pvfTopUrl).origin;
      window.location.href =
        `${logoutEndpoint}?client_id=${clientId}&logout_uri=${encodeURIComponent(pvfLandingUrl)}`;
    };
    this.oidcSecurityService.logoffLocal();
    redirectToCognitoLogout();
  }
}
